import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import debounce from "lodash.debounce";
import { FilterMatchMode } from "primereact/api";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from "primereact/datatable";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { useCallback, useEffect, useRef, useState } from "react";
import { useToast } from "../../../../../Shared/hook/useToast";
import { OfferItemsOrder, Offers } from "../../../Domain/Model/Offers";
import OffersPromoViewModel from "../OffersPromoViewModel";


interface ColumnMeta {
    field: string;
    header: string;
    editable: boolean;
}

export const TypeOffers = () => {
    const title = "Oferta y promociones";

    // const toast = useRef(null);

    const { showSuccess, showError, showWarn, showInfo } = useToast();
    // const [checkedStates, setCheckedStates] = useState<{ [key: string]: boolean }>({});

    const [totalRecords, setTotalRecords] = useState(0);

    const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});

    const [typeOfferImage, setTypeOfferImage] = useState(0);

    const [ordersList, setOrdersList] = useState<OfferItemsOrder[]>([]);

    type LazyParamsType = {
        first: number;
        rows: number;
        };

    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState<LazyParamsType>({
        first: 0,
        rows: 10,
    });

    // const banners = [{}];

    const {
        getOffers,
        offers,
        handleSwitchChange,
        checkedStates,
        updateTableOffers,
        updateOfferOrderLocal,
        removeOfferItemTable
    } = OffersPromoViewModel();

    // useEffect(() => {
    //     console.log("Datos cargados:", banners);
    //     }, [banners]);
    
    useEffect(() => {
        
        //ProductService.getProducts().then((data) => setProducts(data));
            // getProducts();
            const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
            loadOffers(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
        console.log(ordersList);
 
    }, [lazyParams, filters, typeOfferImage]);

 useEffect(() => {
    console.log(ordersList);
}, [ordersList]);
      
    const switchChange = async (checked: boolean, id: number, typeStateUpdate?: string) => {

        try {
            await handleSwitchChange(checked, id, typeStateUpdate!);
            showSuccess("Se Actualizo", "Se ha actualizado el estado con éxito!");
        } catch(error) {
            showError("Error", "Error al actualizar!");
        }
    }
    
    const switchState = (value: Offers) => {
        // console.log("value: ", value.status);
        return (
        <>
            <div className="d-inline switchState">
            <InputSwitch
                checked={checkedStates[value.id]}
                onChange={(e) => switchChange(e.value, value.id, "offer")}
            />
            </div>
        </>
        );
    };

    const loadOffers = async (first: number, rows: number, search: string = "") => {
        setLoading(true);
        const page = Math.floor(first / rows);
        //const search = filters?.global?.value || '';

        // console.log(page);

        try {
            const result = await getOffers(page+1, rows, search, typeOfferImage);
            console.log("Cargando página:", page, "con", rows);
        
            setTotalRecords(result.totalCount);
        } catch (error) {
            console.error("Error al cargar ofertas", error);
        } finally {
            setLoading(false);
        }
    };

    

    const columns: ColumnMeta[] = [
        { field: 'order', header: 'Orden', editable: true },
        { field: 'typeOfferImages', header: 'Tipo Oferta', editable: false },
        { field: 'title', header: 'Título', editable: false },
        { field: 'subTitle', header: 'Subtitulo', editable: false },
        { field: 'status', header: 'Estado', editable: false },
        { field: 'options', header: 'Opciones', editable: false },
    ];

    const confirmDelete = (id: any) => {

        confirmDialog({
            message: '¿Quieres eliminar este registro?',
            header: 'Eliminar confirmación',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => accept(id),
            reject
        });
    };

    
      const accept = async (id: string) => {
        
          let deleted = await removeOfferItemTable(Number(id));
         
          if(deleted){
            showInfo("Confirmada", "has aceptado!");
            const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
            loadOffers(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
            
          } 
      }

      const reject = () => {
           showWarn("Rechazada", "has rechazado!");
      }



    const btnOptions = (id: string, typeOffer: number)=> {
    
        return( 
            <div className="d-inline">
               
                {typeOffer===100 &&
                <>
                    <a href={`/builder-form-images-update/${id}`} className="btn btn-dark">
                        <FontAwesomeIcon icon={icon({name: 'edit'})} />
                    </a>&nbsp;
                </>
                }

                {typeOffer===200 &&
                <>
                    <a href={`/builder-form-slider-update/${id}`} className="btn btn-dark">
                        <FontAwesomeIcon icon={icon({name: 'edit'})} />
                    </a>&nbsp;
                </>
                }

                {typeOffer===300 &&
                <>
                    <a href={`/builder-form-timer-update/${id}`} className="btn btn-dark">
                        <FontAwesomeIcon icon={icon({name: 'edit'})} />
                    </a>&nbsp;
                </>
                }
                &nbsp;
                <button type="button" onClick={()=>confirmDelete(id)}  className="btn btn-dark">
                    <FontAwesomeIcon icon={icon({name: 'trash'})} />
                </button> 
            </div>
        );
    };

    // const handlerOrders = (data: any) => {
    //     const { value } = data?.target;
    //     const id = data.target.id;
    //     const orderValue = Number(value);

    //     setOrdersList(prevOrders => {
    //         const existingOrderIndex = prevOrders.findIndex(order => order.id === Number(id));
    //         if (existingOrderIndex !== -1) {
    //             const updatedOrders = [...prevOrders];
    //             updatedOrders[existingOrderIndex] = { ...updatedOrders[existingOrderIndex], order: orderValue };
    //             return updatedOrders;
    //         }
    //         return prevOrders;
    //     });

    // };
    // const customOrder = (order: number)=> {
    //     return( 
    //         <div className="d-inline">
    //             <InputText style={{ width: '80px' }} value={order.toString()} />
    //         </div>
    //     );
    // };

    const typeOffer = (typeOffer: number)=> {
    
        return( 
            <div className="d-inline">
                {typeOffer===100 &&
                <div className="typeOffer-images">
                   <FontAwesomeIcon icon={icon({name: 'images'})} /> Images
                </div>
                }

                {typeOffer===200 &&
                <div className="typeOffer-carousel">
                   <FontAwesomeIcon icon={icon({name: 'shirt'})} /> Carrusel
                </div>
                }

                {typeOffer===300 &&
                <div className="typeOffer-tempo">
                  <FontAwesomeIcon icon={icon({name: 'clock'})} /> Temporizador
                </div>
                }
                
            </div>
        );
    };


    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const addOrderChange = (id: number, order: number) => {

            setOrdersList(prev => {

            const index = prev.findIndex(x => x.id === id);

            if (index === -1) {

                return [
                    ...prev,
                    {
                        id,
                        order
                    }
                ];
            }

            const updated = [...prev];

            updated[index] = {
                ...updated[index],
                order
            };

            return updated;
        });

    };


   const isUpdatingRef = useRef(false);

    const onCellEditComplete = useCallback(
    async (e: ColumnEvent) => {

        if (isUpdatingRef.current) return;

        isUpdatingRef.current = true;

        try {

            const {
                rowData,
                newValue,
                field,
                originalEvent
            } = e;

            if (rowData[field] === newValue) {
                return;
            }

            switch (field) {

                case "order":

                    if (!isPositiveInteger(newValue)) {

                        originalEvent.preventDefault();

                        return;
                    }

                    break;

                default:

                    if (!String(newValue).trim().length) {

                        originalEvent.preventDefault();

                        return;
                    }

            }

            const value =
                field === "order"
                    ? Number(newValue)
                    : newValue;

            setTimeout(() => {
                updateOfferOrderLocal(rowData.id, value);
                addOrderChange(rowData.id, value);
            }, 0);

        }
        finally {

            isUpdatingRef.current = false;

        }

    },
    [
        updateOfferOrderLocal
    ]);


    const saveOrders = async () => {

        if (ordersList.length === 0) {

            showWarn("Aviso", "No existen cambios.");

            return;
        }

        try {

            await updateTableOffers(ordersList);

            console.log(ordersList);

            showSuccess("Correcto", "Se actualizaron las ofertas.");

            setOrdersList([]);

        }
        catch {

            showError("Error", "No fue posible actualizar.");

        }

    };


    // const onCellEditComplete = useCallback(async (e: ColumnEvent) => {
    //     let { rowData, newValue, field, originalEvent: event } = e;

    //     // Evita disparar doble si no hubo cambio real
    //     if (rowData[field] === newValue) return;

    //     switch (field) {
    //         case 'order':
    //             if (!isPositiveInteger(newValue)) {
    //                 event.preventDefault();
    //                 return;
    //             }
    //             rowData[field] = Number(newValue);
    //             break;
    //         default:
    //             if (!newValue.trim().length) {
    //                 event.preventDefault();
    //                 return;
    //             }
    //             rowData[field] = newValue;
    //     }
    //     const update = await updateTableOffers(rowData);
    //     if(update){
    //         showSuccess("Se Actualizo", "Se ha actualizado el orden con éxito!");
    //          setTimeout(() => {
    //             const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
    //             loadOffers(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
    //         }, 0);
    //     }
    // }, []);


    const cellEditor = (options: ColumnEditorOptions) => {
        // if (options.field === 'state') return noTextEditor();
        // else return textEditor(options);
        return textEditor(options);
    };

    const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText
                type="text"
                value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };


    //  Guardamos el texto en un estado normal
    const [inputValue, setInputValue] = useState("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = useCallback(
    debounce((searchValue: string) => {
        loadOffers(lazyParams.first ?? 0, lazyParams.rows ?? 10, searchValue);
    }, 500),
    [lazyParams]
    );

    // Limpieza del debounce al desmontar
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
    
        setInputValue(value.trim());
        // solo dispara la búsqueda cuando hay un valor completo
        if (value.trim().length > 0) {
            
            debouncedSearch(value.trim());
        } else {
            // Si está vacío, recargar todo sin filtro
            loadOffers(lazyParams.first, lazyParams.rows, "");
        } 
    };

    // const show = ( severity: any, summary: any, detail: any,) => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
    // };

    const header = ()=>{
        // @ts-ignore
        // const value = (filters['global'] as DataTableFilterMetaData)?.value || '';

    return (
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
            <section className="m-0 gap-2 d-flex flex-wrap align-items-center justify-content-start">
                <div className="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" className="btn btn-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <FontAwesomeIcon icon={icon({name: 'plus'})} /> Nueva oferta
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <li><a className="dropdown-item typeOffer-images-btn" href="/builder-form-images"><FontAwesomeIcon icon={icon({name: 'images'})} /> Images</a></li>
                        <li><a className="dropdown-item typeOffer-carousel-btn" href="/builder-form-slider"><FontAwesomeIcon icon={icon({name: 'shirt'})} /> Carrusel</a></li>
                        <li><a className="dropdown-item typeOffer-tempo-btn" href="/builder-form-timer"><FontAwesomeIcon icon={icon({name: 'clock'})} /> Temporizador</a></li>
                    </ul>
                </div>
                 &nbsp;
                <div className="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" className="btn btn-danger dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <FontAwesomeIcon icon={icon({name: 'filter'})} /> Filtrar por tipo
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <li><button className="btn" onClick={()=> setTypeOfferImage(0)}><FontAwesomeIcon icon={icon({name: 'list'})} /> todos</button></li>
                        <li><button className="btn typeOffer-images-btn" onClick={()=> setTypeOfferImage(100)}><FontAwesomeIcon icon={icon({name: 'images'})} /> Images</button></li>
                        <li><button className="btn typeOffer-carousel-btn" onClick={()=> setTypeOfferImage(200)}><FontAwesomeIcon icon={icon({name: 'shirt'})} /> Carrusel</button></li>
                        <li><button  className="btn typeOffer-tempo-btn" onClick={()=> setTypeOfferImage(300)}><FontAwesomeIcon icon={icon({name: 'clock'})} /> Temporizador</button></li>
                    </ul>
                </div>
                <button onClick={saveOrders} className="btn btn-success">
                    <FontAwesomeIcon icon={icon({name: 'save'})} /> Guardar orden de ofertas
                </button>
            </section>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" value={inputValue} onChange={onGlobalFilterChange} placeholder="Buscar..." />
            </span>
        </div>
    )};

    return(
        <div className='container-fluid'>
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Ofertas y promociones</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">{title}</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            
                            <div className="p-2 d-flex">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver las últimas ofertas añadidas
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    {/* <Toast ref={toast} /> */}
                    {/* <ConfirmDialog /> */}
                    <DataTable 
                        value={offers!}
                        lazy 
                        paginator 
                        rows={lazyParams.rows} 
                        first={lazyParams.first} 
                        totalRecords={totalRecords} 
                        loading={loading} 
                        editMode="cell" 
                        rowsPerPageOptions={[5, 10, 15, 20]} 
                        tableStyle={{ minWidth: '50rem' }} 
                        onPage={(e) => setLazyParams({first: e.first, rows: e.rows})} 
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                        // paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}  
                        globalFilterFields={['order', 'type']} 
                        emptyMessage="No se encontraron ofertas." 
                        stateStorage="session"
                        header={header} 
                        filters={filters}
                        onFilter={(e) => {
                            setFilters(e.filters); 
                            // setLazyParams((prev) => ({ ...prev, first: 0 })); // Reinicia a página 0
                             setLazyParams({ ...lazyParams, first: 0, rows: 1 });
                        }}>
                        {columns.map(({ field, header, editable  }) => {
                            return <Column 
                            key={field} 
                            field={field} 
                            header={header}
                            body={(rowData) => {

                                if (!rowData) return null;
                        
                                switch (field) {
                                    // case "order":
                                    //     return customOrder(rowData.order);
                                    case "typeOfferImages":
                                        return typeOffer(rowData.typeOfferImages);

                                    case "status":
                                            return switchState(rowData);
                                    case "options":
                                        return (
                                        <>
                                            {btnOptions(String(rowData.id), rowData.typeOfferImages)}
                                                
                                        </>
                                    );
                                default:
                                return rowData[field];
                                }
                            }}
        
                            editor={ editable ? (options) => cellEditor(options) : undefined} 
                            onCellEditComplete={onCellEditComplete}
                            />
                            })
                        }
                    </DataTable>
                </div>
            </div>
        </div>
    );
}